<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 0 24 24" width="30">
        <path :fill="colorx" d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z"/>
    </svg>
</template>
  
<script>
    export default {
        data: () => ({
    
        }),
        props: {
            colorx: {
                type: String,
                default: '#89899B'
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/shared/icons/WasteSortingIcon.vue